import ChargeHelper from 'features/Charge/chargeHelper';
import KTFormInput, { KTFormInputType } from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

DialogAddBatteryToSlotView.propTypes = {
  slotRow: PropTypes.object.isRequired,
  cabinetId: PropTypes.string,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogAddBatteryToSlotView({ slotRow = {}, cabinetId, onCancel, onDone }) {
  const [loading, setLoading] = useState(false);
  const [brandId, setBrandId] = useState('');
  const [brandList, setBrandList] = useState([]);
  const [modelId, setModelId] = useState('');
  const [modelList, setModelList] = useState([]);
  const [batterySpecsList, setBatterySpecsList] = useState([]);
  const [serialNumber, setSerialNumber] = useState('');
  const [locationCode, setLocationCode] = useState('');

  useEffect(() => {
    ChargeHelper.API.requestGetChargeBrandList({ page: 0, limit: 100 }).then((res) => {
      setBrandList(res?.brands || []);
    });
  }, []);

  useEffect(() => {
    ChargeHelper.API.requestGetBatterySpecs().then((specs) => {
      setBatterySpecsList(Array.isArray(specs) ? specs : []);
    });
  }, []);

  useEffect(() => {
    setModelId('');
    setModelList([]);
    if (!brandId) return;
    ChargeHelper.API.requestGetBatteryBrandModelList(brandId, { page: 0, limit: 100 }).then((res) => {
      setModelList(res?.models || []);
    });
  }, [brandId]);

  const getSpecNameBySpecId = (specIdVal) => {
    if (specIdVal == null) return null;
    const spec = (batterySpecsList || []).find(
      (s) => String(s.specId) === String(specIdVal) || Number(s.specId) === Number(specIdVal)
    );
    return spec?.name ?? null;
  };

  const handleSubmit = async () => {
    if (!brandId) {
      ToastHelper.showError('Vui lòng chọn hãng sản xuất pin');
      return;
    }
    if (!modelId) {
      ToastHelper.showError('Vui lòng chọn loại pin');
      return;
    }
    if (!serialNumber.trim()) {
      ToastHelper.showError('Vui lòng nhập số serial pin');
      return;
    }

    const id = cabinetId ?? slotRow?.cabinetId;
    const slotId = slotRow?.slotId ?? slotRow?.id;
    if (!id || slotId == null) {
      ToastHelper.showError('Không tìm thấy thông tin ngăn pin');
      return;
    }

    const payload = {
      modelId,
      serialNumber: serialNumber.trim(),
      ...(locationCode.trim() ? { bmsId: locationCode.trim() } : {}),
      cabinetId: id,
      slotId,
    };

    setLoading(true);
    const res = await ChargeHelper.API.requestCreateBattery(payload);
    setLoading(false);

    if (res === true) {
      ToastHelper.showSuccess('Thêm pin thành công');
      if (onDone) onDone();
    } else {
      ToastHelper.showError(_.isString(res) ? res : 'Thêm pin thất bại');
    }
  };

  const dropdownClass =
    'btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between';
  const dropdownClassDisabled =
    'btn border-0 dropdown-toggle w-100 d-flex align-items-center justify-content-between bg-light';

  const brandOptions = [
    { name: 'Chọn hãng sản xuất', value: '' },
    ...(brandList || []).map((b) => ({ name: b.name, value: b.brandId })),
  ];

  const modelOptions = [
    { name: 'Chọn loại pin', value: '' },
    ...(modelList || []).map((m) => {
      const specName = getSpecNameBySpecId(m.specId);
      return {
        name: specName || m.name || `Model ${m.modelId}`,
        value: m.modelId,
      };
    }),
  ];

  return (
    <div className="mt-3">
      <div className="row m-0 px-3">
        <div className="col-6 mb-4 px-0 pr-3">
          {UIHelper.buildFormLabel('Hãng sản xuất pin', true)}
          <KTBSDropdown
            name="battery_brand"
            toggleElement={
              <button className={dropdownClass} type="button">
                {brandList.find((b) => b.brandId === brandId)?.name || 'Chọn hãng sản xuất'}
              </button>
            }
            selectedValue={brandId}
            dropdownMenuItems={brandOptions}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: 'min(320px, 60vh)' }}
            onChange={(value) => setBrandId(value)}
            isDropdownForm={true}
          />
        </div>
        <div className="col-6 mb-4 px-0">
          {UIHelper.buildFormLabel('Loại pin', true)}
          <KTBSDropdown
            name="battery_model"
            disabled={!brandId}
            toggleElement={
              <button
                className={!brandId ? dropdownClassDisabled : dropdownClass}
                type="button"
                disabled={!brandId}
                style={!brandId ? { color: '#494968', border: 'none', backgroundColor: '#EEF1FA', fontWeight: '500' } : undefined}
              >
                {(() => {
                  const model = modelList.find((m) => m.modelId === modelId);
                  const name = model ? getSpecNameBySpecId(model.specId) || model.name : null;
                  return name || 'Chọn loại pin';
                })()}
              </button>
            }
            selectedValue={modelId}
            dropdownMenuItems={modelOptions}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: 'min(320px, 60vh)' }}
            onChange={(value) => setModelId(value)}
            isDropdownForm={true}
          />
        </div>

        <div className="col-6 mb-4 px-0 pr-3">
          {UIHelper.buildFormLabel('Số serial pin', true)}
          <KTFormInput
            type={KTFormInputType.text}
            name="serialNumber"
            placeholder="Nhập số serial pin"
            value={serialNumber}
            onChange={(value) => setSerialNumber(value)}
          />
        </div>
        <div className="col-6 mb-4 px-0">
          {UIHelper.buildFormLabel('Mã định vị')}
          <KTFormInput
            type={KTFormInputType.text}
            name="locationCode"
            placeholder="Nhập mã định vị"
            value={locationCode}
            onChange={(value) => setLocationCode(value)}
          />
        </div>
      </div>

      <div
        className="d-flex align-items-center justify-content-end gap-3 p-3"
        style={{ borderTop: `1px solid ${AppColors.gray[200]}` }}
      >
        {UIHelper.buildNegativeButton('Bỏ qua', onCancel, null)}
        {UIHelper.buildGreenButton('Thêm', handleSubmit, null, false, loading)}
      </div>
    </div>
  );
}

export default DialogAddBatteryToSlotView;
